<template>
	<div class="dashboard-container">
		<div class="title">投诉列表</div>
		<div class="screen" style="margin-top: 15px;margin-bottom: 15px;">
			订单号
			<el-input clearable type="text" style="width: 250px;margin-right: 20px;margin-left: 17px;" size="small"
				placeholder="请输订单号" v-model="filter1.text" @keydown.enter.native="getlist()">
			</el-input>
			投诉状态
			<el-select clearable filterable size="small" v-model="filter1.status" @change="getlist()"
				style="width:150px;margin-right:10px;" placeholder="全部">
				<el-option v-for="item in status1" :key="item.value" :label="item.label" :value="item.value" />
			</el-select>
		</div>
		<div class="screen" style="margin-bottom: 15px;">
			投诉时间
			<el-date-picker v-model="filter1.time" type="daterange" value-format="yyyy-MM-dd" @change="getlist()"
				range-separator="至" size="small" placeholder="选择日期" start-placeholder="开始日期" end-placeholder="结束日期"
				style="margin-right: 20px;width: 250px;">
			</el-date-picker>
			投诉类型
			<el-select clearable filterable size="small" v-model="filter1.type" @change="getlist()"
				style="width:150px;margin-right:10px;" placeholder="全部">
				<el-option v-for="item in type3" :key="item.key" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<el-button size="small" type="primary" @click="getlist()">筛选</el-button>
			<el-button size="small" type="primary" @click="getlist()" style="display: flex;float: right;">导出</el-button>
			<!-- <el-button @click="clear1()" size="small" style="margin-left: 10px;">重置</el-button> -->
		</div>
		<el-table :data="tableData1" style="width: 100%" v-loading="loading"
			:header-cell-style="{ background: '#F2F2F4', 'text-align': 'center' }"
			:cell-style="{'text-align': 'center', 'font-size': '14px'}">
			<el-table-column prop="telphone" label="微信支付订单号" width="120px"></el-table-column>
			<el-table-column prop="addTime" label="投诉时间" width="200px"></el-table-column>
			<el-table-column label="问题描述">
				<template slot-scope="scope">
					{{scope.row.content}}
				</template>
			</el-table-column>
			<el-table-column label="订单金额(元)">
				<template slot-scope="scope">
					{{scope.row.content}}
				</template>
			</el-table-column>
			<el-table-column label="申请退款金额(元)">
				<template slot-scope="scope">
					{{scope.row.content}}
				</template>
			</el-table-column>
			<el-table-column label="投诉描述">
				<template slot-scope="scope">
					{{scope.row.content}}
				</template>
			</el-table-column>
			<el-table-column prop="telphone" label="投诉人联系方式" width="120px">
			</el-table-column>
			<el-table-column label="投诉次数">
				<template slot-scope="scope">
					{{scope.row.content}}
				</template>
			</el-table-column>
			<el-table-column prop="type" label="投诉单状态" width="120px">
				<template slot-scope="scope">
					{{ scope.row.type | typeFormat1 }}
				</template>
			</el-table-column>
			<el-table-column width="150" label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="">编辑</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pagechange">
			<el-pagination class="pages" @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="filter1.pageNum" :page-sizes="[10,20,50]" :page-size="filter1.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="filter1.total">
			</el-pagination>
		</div>
	</div>
</template>
<script>
	import {
		url
	} from '../../utils/index.js'
	export default {
		data() {
			return {
				url: url(),
				loading: false,
				// 门店列表
				storelist: [],
				storesEnd: [],
				filter1: {
					id: "",
					status: '',
					type: "",
					like: "",
					text: "",
					time: [], //时间
					total: 0, //页面总数1
					date: [],
					startTime: "",
					endTime: "",
					pageNum: 1, //页码
					pageSize: 10, // 条数
				},
				tableData1: [],
				status1: [
					// {
					// 	value: 1,
					// 	label: '已处理'
					// },
					// {
					// 	value: 0,
					// 	label: '未处理'
					// }
				],
				type3: [
					// {
					// 	value: "1",
					// 	label: "支付问题"
					// },
					// {
					// 	value: "2",
					// 	label: "会员/套餐问题"
					// },
					// {
					// 	value: "3",
					// 	label: "充值问题"
					// },
					// {
					// 	value: "4",
					// 	label: "其他问题"
					// }
				]
			}
		},
		filters: {
			typeFormat1(val) {
				switch (val) {
					case 1:
						return "支付问题";
					case 2:
						return "会员/套餐问题";
					case 3:
						return "充值问题";
					case 4:
						return "其他问题";
					default:
						return "/";
				}
			}
		},
		mounted() {
			// this.getlist()
			// this.getstore()
		},
		methods: {
			//重置意见筛选
			// clear1() {
			// 	this.filter1 = {
			// 		text: "",
			// 		time: "", //时间
			// 		type: "", //发型师
			// 		status: "",
			// 		total: 0, //页面总数1
			// 		startTime: "",
			// 		endTime: "",
			// 		pageNum: 1, //页码
			// 		pageSize: 10, // 条数
			// 	}
			// 	this.getlist()
			// },
			//获取所有门店
			getstore() {
				this.$http.get("store/list?").then(function(res) {
					if (res.body.code == "200") {
						res.body.data.forEach(ele => {
							if (ele.businessType == 1) {
								this.storesEnd.push(ele) //结业门店
							} else {
								this.storelist.push(ele) //营业门店
							}
						})
					}
				})
			},
			getlist() {
				var a = {
					page: this.filter1.pageNum - 1,
					size: this.filter1.pageSize,
					like: this.filter1.like,
					text: this.filter1.text,
					type: this.filter1.type
				}
				if (this.filter1.time != '' && this.filter1.time != null) {
					a.startTime = this.filter1.time[0]
					a.endTime = this.filter1.time[1]
				}
				if (this.filter1.status != null)
					a.status = this.filter1.status

				if (a.type == null || a.type == '')
					delete a.type
				if (a.text == null || a.text == '') {
					delete a.like
					delete a.text
				}
				this.$http.get("dQuestionFeedback/findQuestionFeedback", {
					params: a
				}, {
					emulateJSON: true
				}).then(function(res) {
					if (res.body.code == "200") {
						this.tableData1 = res.body.data;
						this.filter1.total = res.body.total;
					}
				})
			},
			getCovidExpor() {
				window.location.assign(this.url + "dWorker/covidUploadExpor");
			},
			handleSizeChange(val) {
				this.filter1.pageSize = val
			},
			handleCurrentChange(val) {
				this.filter1.pageNum = val
			}
		}
	}
</script>

<style scoped="scoped" lang="less">
	.red {
		color: red;
	}

	.dashboard-container {
		box-sizing: border-box;

		.title {
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #3e3e3e;
			margin-bottom: 0px;
			margin-top: 0px;
		}

		.pagechange {
			margin-top: 20px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
		}

	}
</style>